import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    NgZone,
    OnInit,
    Output,
    ViewEncapsulation,
} from "@angular/core";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { S25DropdownAbstract } from "../s25.dropdown.abstract";
import { Season, SeasonsService } from "../../student-housing/seasons/seasons.service";
import { S25Util } from "../../../util/s25-util";
import { UserprefService } from "../../../services/userpref.service";
import { S25Datefilter } from "../../s25-dateformat/s25.datefilter.service";
import { S25ItemI } from "../../../pojo/S25ItemI";

@TypeManagerDecorator("s25-ng-season-dropdown")
@Component({
    selector: "s25-ng-season-dropdown",
    template: `
        @if (items) {
            <s25-generic-dropdown
                [style.width]="'90%'"
                class="ngInlineBlock"
                [value]="value()"
                [onSelect]="onSelect"
                [items]="items"
                [staticItems]="staticItems"
                [autoOpen]="autoOpen"
                [alwaysOpen]="alwaysOpen"
                [hideSearch]="hideSearch"
                [focusFirst]="false"
                [searchEnabled]="true"
                [apiBean]="apiBean"
                [placeholder]="'Select a Season'"
                [resetSelectedOnCleanup]="resetSelectedOnCleanup"
                (valueChange)="onValueChange($event)"
            />
            <button class="btn btn-flat c-margin-left--quarter" (click)="refresh()" aria-label="Refresh">
                <s25-ng-icon [type]="'refresh'" [ariaLabel]="false" />
            </button>
        }
    `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class S25SeasonDropdownComponent extends S25DropdownAbstract implements OnInit {
    @Input() selectedSeason?: Season;
    @Output() selectedSeasonChange = new EventEmitter<Season>();

    seasons: Season[];
    dateFormat: string;

    onValueChange(data: any) {
        super.onValueChange(data);
        this.selectedSeason = undefined;
        const matches = this.seasons.filter((s) => s.seasonId === this.value()!.itemId);
        if (matches.length) {
            this.selectedSeason = matches[0];
        }
        this.selectedSeasonChange.emit(this.selectedSeason);
    }

    constructor(
        private zone: NgZone,
        private elementRef: ElementRef,
    ) {
        super();
    }

    seasonToItem = (season: Season): S25ItemI => {
        return {
            itemId: season.seasonId,
            itemName:
                season.code +
                ": " +
                S25Datefilter.transform(season.housingStartDate, this.dateFormat) +
                " - " +
                S25Datefilter.transform(season.housingEndDate, this.dateFormat),
            itemDesc: season.descr,
        };
    };

    refresh() {
        S25Util.all({
            dateFormat: UserprefService.getS25Dateformat(),
            seasons: SeasonsService.getSeasons(),
        }).then((resp) => {
            this.zone.run(() => {
                this.dateFormat = resp.dateFormat;
                this.seasons = resp.seasons || [];
                if (this.selectedSeason) {
                    this.value.set(this.seasonToItem(this.selectedSeason));
                }
                this.items = this.seasons.map((s: Season) => {
                    return this.seasonToItem(s);
                });
                this.onLoad && this.onLoad();
                this.cd.detectChanges();
            });
        });
    }

    ngOnInit() {
        this.refresh();
    }
}
